<template>
    <div class="text-xs-center">
      <v-dialog
        v-model="loader"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="secondary"
          dark
        >
          <v-card-text>
            {{ loaderText }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
  export default {
    name: 'app-loader',
    data: () => ({
      dialog: ''
    }),

    watch: {
    },

    computed: {
      loader: {

          get() {
            return this.$store.getters.loader
          },

        set() {
          this.$store.commit('SET_LOADER', newValue)
        }
      },

      loaderText() {
        return this.$store.getters.loaderText
      }
    }
  }
</script>